import {register} from '../../../assets/js/modules/eventMap';

const getContainerElFromChildEl = (childEl) =>
    childEl?.closest('[data-kui-chat-prompt]');

const getInputEl = () =>
    document.querySelector('[data-kui-chat-prompt] textarea');

const autoResizeInput = (el) => {
    if (!CSS.supports('field-sizing', 'content')) {
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
    }
};

const retainFocusOnReload = () => {
    if (!(performance.navigation.type === 1)) {
        return;
    }

    const inputEl = getInputEl();

    if (!inputEl || inputEl.hasAttribute('autofocus')) {
        return;
    }

    inputEl.focus();
};

const retainFocusOnSubmit = () => {
    // Add small delay to let screen reader finish announcing live region
    setTimeout(() => {
        const inputEl = getInputEl();

        if (!inputEl) {
            return;
        }

        inputEl.focus();
    }, 300);
};

const submitOnEnter = (el, event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();

        const formEl = el.form;

        if (!formEl) {
            return;
        }

        const submitButtonEl = getContainerElFromChildEl(formEl)?.querySelector(
            `button[type="submit"][form="${formEl.id}"]`
        );

        if (!submitButtonEl) {
            return;
        }

        // Triggers formSubmit.js
        submitButtonEl.click();
    }
};

const chatPrompt = () => {
    register('chatPrompt', {autoResizeInput, submitOnEnter});
};

export {chatPrompt, retainFocusOnReload, retainFocusOnSubmit};
